import React, { useState, useEffect } from "react";
import { Menu, Dropdown, Icon, Table, Modal } from "antd";
import menuIcon from "../../../../assets/images/DeathModuleNew/Menu.png";
import plaidIcon from "../../../../assets/images/budget/plaidlogo.png";
import calanderIcon from "../../../../assets/images/budget/calander.png";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import "../AddTransaction/AddTransaction.css";
import "./style/recurringPattren.css";
import BUDGET_API from "../../../../apis/budget.api";
import DEATH_API from "../../../../apis/death.api";
import { Select } from "antd";
import moment from "moment";
const { Option } = Select;

export const SystemRecurringTransactions = ({
  fetchRecuuring,
  recurringGet,
}) => {
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [recurringTransactions, setRecurringTransactions] = useState([]);
  const [cachedData, setCachedData] = useState({});
  const [loading, setLoading] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedObject, setSelectedObject] = useState([]);
  const [clientTransactions, setClientTransactions] = useState(null);
  const [currentTokenPage, setCurrentTokenPage] = useState(1);
  const [totalTokenPages, setTotalTokenPages] = useState(1);
  const [totalTokenRecords, setTotalTokenRecords] = useState(0);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const sortedData =
    selectedObject &&
    [...selectedObject].sort((a, b) => {
      if (sortConfig.key === "date") {
        return sortConfig.direction === "asc"
          ? new Date(a.date) - new Date(b.date)
          : new Date(b.date) - new Date(a.date);
      } else if (sortConfig.key === "amount") {
        return sortConfig.direction === "asc"
          ? a.amount - b.amount
          : b.amount - a.amount;
      }
      return 0;
    });
  console.log("sortedData", sortedData);
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction:
        prevConfig.key === key && prevConfig.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return null; // No icon if the column is not sorted

    // Return both icons, with the appropriate one being active
    return (
      <>
        {sortConfig.direction === "asc" ? (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "white", fontSize: "8px" }}>▲</span>{" "}
            {/* Upward arrow */}
            <span style={{ color: "gray", fontSize: "8px" }}>▼</span>{" "}
            {/* Downward arrow (inactive) */}
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "gray", fontSize: "8px" }}>▲</span>{" "}
            {/* Upward arrow (inactive) */}
            <span style={{ color: "white", fontSize: "8px" }}>▼</span>{" "}
            {/* Downward arrow */}
          </div>
        )}
      </>
    );
  };
  const cols = [
    {
      title: "Item",
      dataIndex: "itemName",
      sorter: (a, b) => (a.itemName || a.token || "").localeCompare(b.itemName || b.token || ""),
      render: (fileName, record) => {
        return record.itemName || record.token ? (
          <React.Fragment>
            <div
              style={{
                display: "flex",
                gap: "6px",
                cursor: "pointer",
                alignItems: "center",
              }}
              onClick={() => {
                getSelectedRecords(record);
              }}
            >
              <img
                style={{ borderRadius: "50%" }}
                height={34}
                width={34}
                src={record.itemLogo ? record.itemLogo : plaidIcon}
              ></img>
              <div>
                <div>{record.itemName || record.token}</div>
                <div
                  style={{
                    color:
                      record.frequency &&
                      record.frequency.toLowerCase() === "irregular"
                        ? "red"
                        : "#2a3da3",
                    fontStyle: record.frequency &&
                      record.frequency.toLowerCase() === "irregular" && "italic",
                    fontWeight: "bold",
                  }}
                >
                  {record.frequency && record.frequency}
                </div>
                {record.frequency &&
                  record.frequency.toLowerCase() !== "irregular" && (
                    <div style={{ color: "#79797D", fontWeight: "lighter" }}>
                      {record.frequency.toLowerCase() === "monthly"
                        ? "1 Transaction"
                        : record.count && record.count + " " + "Transactions"}
                    </div>
                  )}
              </div>
            </div>
          </React.Fragment>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Bank",
      dataIndex: "bankName",
      sorter: (a, b) => (a.bankName || a.accountName || "").localeCompare(b.bankName || b.accountName || ""),
      render: (fileName, record) => {
        return record.bankName || record.accountName ? (
          <div>
            {record.accountVaired ? (
              "Vaired"
            ) : (
              <div>
                <div>
                  {record.accountName
                    ? `${record.accountName}`
                    : record.bankName || ""}
                </div>
                {record.accountType && (
                  <span style={{ color: "black" }}>{record.accountType}</span>
                )}
              </div>
            )}
          </div>
        ) : record.paidUsing == "Cash" ? (
          "Cash"
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Account",
      dataIndex: "bankName",
      sorter: (a, b) =>
        (a.accountNumber || "").localeCompare(b.accountNumber || ""),
      render: (fileName, record) => {
        return record.accountNumber ? (
          <div>
            {record.accountVaired ? (
              "Vaired"
            ) : (
              <div>{"****" + record.accountNumber}</div>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => {
        const amountA = parseFloat(a.amount);
        const amountB = parseFloat(b.amount);
        // Toggle sorting order directly
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (fileName, record) => (
        <div
          style={{
            width: "100%",
            fontWeight: "bold",
            // color: record < 0 ? "#00A27B" : "",
            color: record.amount < 0 ? "black" : "#00A27B",
          }}
        >
          {record.amount
            ? !isNaN(record.amount)
              ? record.amountVaired
                ? "Varied"
                : `${
                    record.amount && record.amount < 0
                      ? "$" +
                        record.amount
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : "$" +
                        record.amount
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }`
              : "N/A"
            : "N/A"}
        </div>
      ),
    },
    {
      title: "Due",
      dataIndex: "dueDate",
      sorter: (a, b) => (a.dueDate || "").localeCompare(b.dueDate || ""),
      render: (fileName, record) => {
        if (record.dueDate) {
          const dueDate = moment(record.dueDate);
          const today = moment().startOf("day");

          if (
            record.frequency &&
            record.frequency.toLowerCase() === "irregular"
          ) {
            return "Varied";
          } else {
            if (dueDate.isBefore(today)) {
              return (
                <span style={{ color: "red", fontWeight: "bold" }}>
                  Expired
                </span>
              );
            } else {
              return dueDate.format("MM-DD-YYYY");
            }
          }
        } else {
          if (
            record.frequency &&
            record.frequency.toLowerCase() === "irregular"
          ) {
            return "Varied";
          }
          return "N/A";
        }
      },
    },
  ];
  function calculateDueStatus(record) {
    const currentDate = new Date();
    let dueDate = new Date(record.dueDate);

    let nextDueDate = new Date(dueDate); // Start from the original due date
    const frequency = record.frequency && getFrequency(record.frequency);
    switch (frequency) {
      case "Monthly":
        // Set to the same day in the current month if today hasn’t passed the due day, else set it to the next month
        nextDueDate.setFullYear(currentDate.getFullYear());
        nextDueDate.setMonth(currentDate.getMonth());
        nextDueDate.setDate(dueDate.getDate());

        if (currentDate > nextDueDate) {
          nextDueDate.setMonth(currentDate.getMonth() + 1);
        }
        break;

      case "Weekly":
        // Move to the next 7-day cycle until it’s in the future
        while (nextDueDate <= currentDate) {
          nextDueDate.setDate(nextDueDate.getDate() + 7);
        }
        break;

      case "Yearly":
        // Set to the same day of this year or next year if today has passed this year’s due date
        nextDueDate.setFullYear(currentDate.getFullYear());
        nextDueDate.setMonth(dueDate.getMonth());
        nextDueDate.setDate(dueDate.getDate());

        if (currentDate >= nextDueDate) {
          nextDueDate.setFullYear(currentDate.getFullYear() + 1);
        }
        break;

      default:
        return "Expired";
    }

    if (dueDate.toDateString() === currentDate.toDateString()) {
      return "Today";
    } else if (dueDate < currentDate) {
      const timeDifference = nextDueDate.getTime() - currentDate.getTime(); // Difference in milliseconds
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
      return `In ${daysDifference} days`;
      // return `Next: ${nextDueDate.toDateString()}`;
      // return "Expired";
    } else {
      const timeDifference = dueDate.getTime() - currentDate.getTime(); // Difference in milliseconds
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
      return `In ${daysDifference} days`;
      // return `${moment(record).format("MM-DD-YYYY")} (${daysDifference} days)`;
    }
  }
  function getFrequency(days) {
    if (days >= 364 && days <= 366) {
      return "Yearly";
    } else if (days >= 56 && days <= 62) {
      return "Bimonthly";
    } else if (days >= 28 && days <= 32) {
      return "Monthly";
    } else if (days >= 13 && days <= 17) {
      return "Biweekly";
    } else if (days >= 5 && days <= 9) {
      return "Weekly";
    } else {
      return "Irregular";
    }
  }
  const getRecurringTransactons = async (page) => {
    if (cachedData && cachedData[page]) {
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      let data = await BUDGET_API.fetchSystemRecurringTransactions(page);
      if (data && data.data) {
        setCachedData((prevState) => ({
          ...prevState,
          [page]: data,
        }));
        updateStateWithData(data);
        // if (data.data.transactions) {
        //   setRecurringTransactions(data.data.transactions);
        // }
        console.log("alldata", data.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getSelectedRecords = async (record) => {
    setDetailsModal(true);
    setCurrentRecord(record);
    await getClientTokenBasedTransactions(record.id, currentPage, 10);
  };
  const getClientTokenBasedTransactions = async (categoryId, page, limit) => {
    try {
      setLoading(true);
      let data = await BUDGET_API.fetchRecurringAppliedTransaction(
        categoryId,
        page,
        limit
      );
      if (data && data.data.transactions) {
        // setSelectedObject(data.data.transactions);
        setSelectedObject((prevItems) => [
          ...prevItems,
          ...data.data.transactions,
        ]);
        setTotalTokenPages(data.data.totalPages);
        setTotalTokenRecords(data.data.totalRecords);
        setCurrentTokenPage(page);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } =
      document.getElementById("transactions-main");
    console.log("Scroll Top:", scrollTop);
    console.log("Scroll Height:", scrollHeight);
    console.log("Client Height:", clientHeight);

    if (scrollTop + clientHeight >= scrollHeight) {
      console.log("Bottom of the scroll reached.");
      console.log("pageee", currentTokenPage, totalTokenPages);
      if (currentTokenPage < totalTokenPages) {
        console.log("Fetching more items...");
        getClientTokenBasedTransactions(
          currentRecord.id,
          currentTokenPage + 1,
          10
        );
      }
    }
  };
  //  useEffect(() => {
  //     console.log("Attaching scroll event listener.");
  //     const cardsMainElement = document.getElementById("transactions-main");
  //     cardsMainElement && cardsMainElement.addEventListener("scroll", handleScroll);
  //     return () => {
  //       console.log("Removing scroll event listener.");
  //       cardsMainElement && cardsMainElement.removeEventListener("scroll", handleScroll);
  //     };
  //   }, [currentTokenPage, totalTokenPages]);
  const handleCancel = () => {
    setDetailsModal(false);
    setSelectedObject([]);
    setCurrentTokenPage(1);
    setTotalTokenPages(1);
    setTotalTokenRecords(0);
    setCurrentRecord(null);
  };
  const getRecurringTransactonsAfterDelete = async (page) => {
    console.log("fetchRecuuring", fetchRecuuring, page);
    try {
      setLoading(true);
      let data = await BUDGET_API.fetchSystemRecurringTransactions(page);
      if (data && data.data) {
        setCachedData((prevState) => ({
          ...prevState,
          [page]: data,
        }));
        updateStateWithData(data);
        // if (data.data.transactions) {
        //   setRecurringTransactions(data.data.transactions);
        // }
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const updateStateWithData = (datares) => {
    console.log("datares", datares);
    if (datares && datares.data && datares.data.transactions) {
      const formattedTransactions = datares.data.transactions.map((item) => ({
        id: item.recurringToken.id,
        token: item.recurringToken.token,
        frequency: item.recurringToken.frequency,
        accountVaired:
          item.recurringToken.accountVaired &&
          item.recurringToken.accountVaired === 1
            ? true
            : false,
        amountVaired:
          item.recurringToken.amountVaired &&
          item.recurringToken.amountVaired === 1
            ? true
            : false,
        dueDate: item.recurringToken.dueDate,
        transactionId: item.transaction.id,
        accountName: item.transaction.account,
        accountType: item.transaction.accountType,
        accountNumber: item.transaction.accountNumber,
        amount: item.transaction.amount,
        date: item.transaction.date,
      }));
      if (formattedTransactions) {
        setRecurringTransactions(formattedTransactions);
      }
      setTotalPages(datares.data.totalPages);
    }
    // if (datares && datares.data) {
    //   setTotalPages(Math.ceil(datares.data.totalPages));
    // }
  };
  const getClientTransactions = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBudgetTransaction();
      if (data && data.data) {
        const allAccountTransactions = data.data;
        setClientTransactions(allAccountTransactions);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    getRecurringTransactons(currentPage);
    // getClientTransactions();
  }, [currentPage]);
  useEffect(() => {
    getRecurringTransactonsAfterDelete(1);
  }, [fetchRecuuring, recurringGet]);

  const tags = [
    "This Month",
    "Last Month",
    "Last Three Month",
    "Last Six Month",
    "This Year",
    "Last Year",
    // "All Time",
  ];
  return (
    <div className="recurring-token-table" style={{ position: "relative" }}>
      <div
        className="budgetcreate"
        style={{ gap: "1rem", justifyContent: "space-between" }}
      >
        <h3 className="incomecardheading">System Recurring Transactions</h3>
        <div
          style={{
            marginBottom: "0px",
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <input
            style={{ marginBottom: "0px", height: "33px" }}
            className="searchStyle"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <div className="filterIcons">
            <Select
              suffixIcon={
                <img src={calanderIcon} height={16} width={17} alt="icon"></img>
              }
              showSearch
              style={{ width: 200, outline: "none", border: "none" }}
              // value={filterData ? filterData : "This Month"}
              placeholder="Select Filter"
              onChange={(value, id) => {
                console.log("value", value);
                // setFilterData(value);
                // handleApplyFilter(value);
              }}
            >
              {tags &&
                tags.map((item, index) => (
                  <Option key={index} value={item}>
                    {item}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
      </div>
      <Table
        columns={cols}
        dataSource={recurringTransactions && recurringTransactions}
        pagination={{
          total: totalPages * 10, // Assuming 10 items per page
          current: currentPage,
          onChange: (page) => {
            setCurrentPage(page);
          },
          pageSize: 10, // Number of items per page
        }}
      />
      <Modal
        visible={detailsModal}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Transaction Details</h3>
        <h3 className="modaltitle">{totalTokenRecords} Transactions</h3>

        <div>
          <div
            className=""
            style={{ height: "18rem", maxHeight: "18rem", overflow: "auto" }}
            id="transactions-main"
            onScroll={handleScroll}
          >
            <NewLoader isLoading={loading} />
            {sortedData && sortedData.length > 0 ? (
              <table id="clients">
                <thead>
                  <tr>
                    <th
                      onClick={() => handleSort("date")}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Date {renderSortIcon("date")}
                    </th>
                    <th>Name</th>
                    <th>Category</th>
                    <th
                      onClick={() => handleSort("amount")}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Amount {renderSortIcon("amount")}
                    </th>
                  </tr>
                </thead>
                <tbody style={{}}>
                  {sortedData &&
                    sortedData.map((data, index) => (
                      <tr key={index}>
                        <td>
                          {data.transaction && data.transaction.date
                            ? moment(data.transaction.date).format("MM-DD-YYYY")
                            : "N/A"}
                        </td>
                        <td>
                          {data.transaction && data.transaction.itemName
                            ? data.transaction.itemName
                            : "N/A"}
                        </td>
                        <td>
                          {data.transaction &&
                          data.transaction.categoryFromPlaid
                            ? data.transaction.categoryFromPlaid
                            : "N/A"}
                        </td>
                        <td>
                          {" "}
                          ${" "}
                          {data.transaction && data.transaction.amount
                            ? `${data.transaction.amount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                            : "0"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : (
              <h3 className="inputTitle">
                {loading
                  ? "Fetching Transactions..."
                  : "No Transaction to Show"}
              </h3>
            )}
          </div>
        </div>

        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Close
          </button>
        </div>
      </Modal>
      <NewLoader isLoading={loading} />
    </div>
  );
};
